// ═══ Hercules Cart Drawer ═══════════════════════════════════════
const $ = id => document.getElementById(id);
const qtyTimers = {};
const variantCache = {};
let cartAutoCloseTimer;
let refreshInFlight = false;
let refreshPending = false;
let toastTimer;
let gwpInFlight = false;

const _origFetch = window.fetch.bind(window);

function getCartEl() { return document.getElementById('cart'); }

function getGwpVariants() {
  const el = getCartEl();
  if (!el) return [];
  return [el.dataset.gwp1Variant, el.dataset.gwp2Variant, el.dataset.subGwpVariant].filter(Boolean);
}

function getNonGwpTotal(cart) {
  const gwpVariants = getGwpVariants();
  return cart.items.reduce((t, i) => gwpVariants.includes(String(i.variant_id)) ? t : t + i.final_line_price, 0);
}

function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

function openCart() {
  $('cart').classList.add('open');
  $('overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCart();
}

function closeCart() {
  $('cart').classList.remove('open');
  $('overlay').classList.remove('open');
  document.body.style.overflow = '';
}

function resetAutoClose() {}

function refreshCart() {
  if (refreshInFlight) { refreshPending = true; return; }
  refreshInFlight = true;
  _origFetch('/cart.js')
    .then(r => { if (r.status === 429) throw new Error('Rate limited'); return r.json(); })
    .then(applyCart)
    .catch(err => console.warn('[cart] refresh failed:', err.message))
    .finally(() => {
      refreshInFlight = false;
      if (refreshPending) { refreshPending = false; setTimeout(refreshCart, 300); }
    });
}

function applyCart(cart) {
  updateBadge(cart.item_count);
  updateShippingBar(getNonGwpTotal(cart), cart);
  updateFooter(cart);
  updateSubGwpLabel(cart);
  reRenderItems(cart);
  handleGWP(cart);
}

function updateBadge(count) {
  document.querySelectorAll('.cart-badge, #hbadge, #cpill').forEach(el => el.textContent = count);
  document.querySelectorAll('cart-count').forEach(el => {
    el.textContent = count;
    el.setAttribute('data-count', count);
  });
}

function updateShippingBar(totalCents, cart) {
  const el = getCartEl();
  if (!el) return;
  const shipThreshold = 130 * 100;
  const gwp1Threshold = parseFloat(el.dataset.gwp1Threshold) * 100 || 15000;
  const gwp2Threshold = parseFloat(el.dataset.gwp2Threshold) * 100 || 20000;
  const gwp1Variant = el.dataset.gwp1Variant || '';
  const gwp2Variant = el.dataset.gwp2Variant || '';
  const gwp1Enabled = el.dataset.gwp1Enabled === 'true';
  const gwp2Enabled = el.dataset.gwp2Enabled === 'true';
  const gwp1Label = el.dataset.gwp1Label || 'Free Mystery Box';
  const gwp2Label = el.dataset.gwp2Label || 'Free Duffel Bag';
  const items = cart?.items || [];
  const gwp1InCart = items.some(i => String(i.variant_id) === String(gwp1Variant));
  const gwp2InCart = items.some(i => String(i.variant_id) === String(gwp2Variant));

  const sf = $('ship-fill'), sl = $('ship-lbl');
  if (sf) sf.value = Math.min(100, (totalCents / shipThreshold) * 100);
  if (sl) sl.innerHTML = totalCents >= shipThreshold
    ? `<span class="ship-done">✓ Free Shipping unlocked!</span>`
    : `Add <strong>$${((shipThreshold - totalCents) / 100).toFixed(2)}</strong> more for Free Shipping 🚚`;

  [{f:'gwp1-fill', l:'gwp1-lbl', en:gwp1Enabled, in:gwp1InCart, th:gwp1Threshold, lbl:gwp1Label},
   {f:'gwp2-fill', l:'gwp2-lbl', en:gwp2Enabled, in:gwp2InCart, th:gwp2Threshold, lbl:gwp2Label}].forEach(g => {
    const f = $(g.f), l = $(g.l);
    if (f) f.value = Math.min(100, (totalCents / g.th) * 100);
    if (l) l.innerHTML = !g.en ? '' : g.in
      ? `<span class="ship-done">✓ ${g.lbl} added!</span>`
      : totalCents >= g.th
        ? `<span class="ship-done">✓ ${g.lbl} unlocked!</span>`
        : `Add <strong>$${((g.th - totalCents) / 100).toFixed(2)}</strong> more — ${g.lbl}`;
  });
}

function updateFooter(cart) {
  const foot = $('foot');
  if (!foot) return;
  foot.style.display = cart.item_count === 0 ? 'none' : '';

  const gwpVariants = getGwpVariants();
  const nonGwpItems = cart.items.filter(i => !gwpVariants.includes(String(i.variant_id)) && i.final_price > 0);
  const finalTotal = nonGwpItems.reduce((t, i) => t + i.final_line_price, 0);
  const savings = nonGwpItems.reduce((t, i) => {
    const d = i.original_line_price - i.final_line_price;
    return d > 0 ? t + d : t;
  }, 0);

  const sub = $('sub'), total = $('total');
  if (sub) sub.textContent = formatMoney(finalTotal);
  if (total) total.textContent = formatMoney(finalTotal);

  const savRow = $('sav-row'), savAmt = $('sav-amt');
  if (savRow && savAmt) {
    if (savings > 0) {
      savAmt.textContent = '−' + formatMoney(savings);
      savRow.style.display = '';
    } else {
      savRow.style.display = 'none';
    }
  }
}

function updateSubGwpLabel(cart) {
  const el = getCartEl();
  const lbl = $('sub-gwp-lbl');
  if (!lbl || !el || el.dataset.subGwpEnabled !== 'true' || !el.dataset.subGwpVariant) return;
  const hasSub = cart.items.some(i =>
    i.selling_plan_allocation != null && String(i.variant_id) !== String(el.dataset.subGwpVariant)
  );
  lbl.innerHTML = hasSub
    ? `<span class="ship-done">✓ First-time Subscriber Gift unlocked!</span>`
    : `🎁 Subscribe to any product to unlock a <strong>Free First-time Subscriber Gift</strong>`;
}

function handleGWP(cart) {
  const el = getCartEl();
  if (!el) return;
  if (gwpInFlight) return;

  const tiers = [
    { enabled: el.dataset.gwp1Enabled === 'true', variantId: el.dataset.gwp1Variant, threshold: parseFloat(el.dataset.gwp1Threshold) * 100 },
    { enabled: el.dataset.gwp2Enabled === 'true', variantId: el.dataset.gwp2Variant, threshold: parseFloat(el.dataset.gwp2Threshold) * 100 }
  ];

  const total = getNonGwpTotal(cart);
  const promises = [];

  tiers.forEach(tier => {
    if (!tier.enabled || !tier.variantId) return;
    const matches = cart.items.filter(i => String(i.variant_id) === String(tier.variantId));
    const qualified = total >= tier.threshold;

    if (qualified && matches.length === 0) {
      promises.push(_origFetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: tier.variantId, quantity: 1 })
      }));
    } else if (qualified && matches.length > 1) {
      matches.slice(1).forEach(dup => {
        fadeOutItem(dup.key);
        promises.push(_origFetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: dup.key, quantity: 0 })
        }));
      });
    } else if (qualified && matches[0].quantity > 1) {
      promises.push(_origFetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: matches[0].key, quantity: 1 })
      }));
    } else if (!qualified && matches.length > 0) {
      matches.forEach(dup => {
        fadeOutItem(dup.key);
        promises.push(_origFetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: dup.key, quantity: 0 })
        }));
      });
    }
  });

  const subEnabled = el.dataset.subGwpEnabled === 'true';
  const subVariant = el.dataset.subGwpVariant;
  if (subEnabled && subVariant) {
    const hasSub = cart.items.some(i => i.selling_plan_allocation != null && String(i.variant_id) !== String(subVariant));
    const subMatches = cart.items.filter(i => String(i.variant_id) === String(subVariant));

    if (hasSub && subMatches.length === 0) {
      promises.push(_origFetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: subVariant, quantity: 1 })
      }));
    } else if (hasSub && subMatches.length > 1) {
      subMatches.slice(1).forEach(dup => {
        fadeOutItem(dup.key);
        promises.push(_origFetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: dup.key, quantity: 0 })
        }));
      });
    } else if (hasSub && subMatches[0].quantity > 1) {
      promises.push(_origFetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: subMatches[0].key, quantity: 1 })
      }));
    } else if (!hasSub && subMatches.length > 0) {
      subMatches.forEach(dup => {
        fadeOutItem(dup.key);
        promises.push(_origFetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: dup.key, quantity: 0 })
        }));
      });
    }
  }

  if (promises.length === 0) return;

  gwpInFlight = true;
  Promise.all(promises)
    .then(() => _origFetch('/cart.js').then(r => r.json()))
    .then(updated => {
      updateBadge(updated.item_count);
      updateShippingBar(getNonGwpTotal(updated), updated);
      updateFooter(updated);
      reRenderItems(updated);
      updateSubGwpLabel(updated);
    })
    .catch(err => console.warn('[cart] GWP sync failed:', err.message))
    .finally(() => { gwpInFlight = false; });
}

function shipBarHTML() {
  return `
    <div class="ship-bar" id="ship-bar">
      <div class="ship-label" id="ship-lbl"></div>
      <progress id="ship-fill" class="ship-progress" value="0" max="100"></progress>
      <div class="ship-label ship-label-stacked" id="gwp1-lbl"></div>
      <progress id="gwp1-fill" class="ship-progress ship-progress-stacked" value="0" max="100"></progress>
      <div class="ship-label ship-label-stacked" id="gwp2-lbl"></div>
      <progress id="gwp2-fill" class="ship-progress ship-progress-stacked" value="0" max="100"></progress>
      <div class="ship-label ship-label-stacked" id="sub-gwp-lbl"></div>
    </div>`;
}

function itemHTML(item, gwpVariants) {
  const isFree = item.final_price === 0 || gwpVariants.includes(String(item.variant_id));
  const hasDiscount = item.original_line_price !== item.final_line_price;
  const isSub = item.selling_plan_allocation?.selling_plan != null;
  const variantLine = item.variant_title && item.variant_title !== 'Default Title'
    ? `<div class="ivar">${item.variant_title}</div>` : '';
  const subLine = isSub
    ? `<span class="sub-tag">Subscribe & Save</span><div class="ifreq">${item.selling_plan_allocation.selling_plan.name}</div>` : '';
  const qtyBlock = isFree ? '<div></div>' : `
    <div class="qty">
      <button type="button" onclick="chQty('${item.key}',-1)">−</button>
      <input id="q-${item.key}" class="qty-input" type="number" min="0" value="${item.quantity}" data-prev="${item.quantity}"
        oninput="setQty('${item.key}',this.value)" onfocus="this.select()"/>
      <button type="button" onclick="chQty('${item.key}',1)">+</button>
    </div>`;
  const priceBlock = `
    <div class="iprice">
      ${(isFree && item.final_price > 0) || (!isFree && hasDiscount) ? `<div class="was">${formatMoney(item.original_line_price)}</div>` : ''}
      <div class="now ${isFree ? 'now-free' : ''}" id="p-${item.key}">${isFree ? 'Included' : formatMoney(item.final_line_price)}</div>
    </div>`;
  const removeBtn = isFree ? '' : `
    <button class="rm" onclick="rmItem('${item.key}')" title="Remove" aria-label="Remove item">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
        <path d="M10 11v6M14 11v6"></path>
        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
      </svg>
    </button>`;
  const thumbInner = item.image
    ? `<img src="${item.image}" alt="${item.product_title}">`
    : item.product_title.slice(0,4).toUpperCase();

  return `
    <div class="item" data-key="${item.key}">
      <div class="thumb">${thumbInner}</div>
      <div class="info">
        <div class="iname">${item.product_title}</div>
        ${variantLine}
        ${subLine}
        <div class="ifoot">
          ${qtyBlock}
          ${priceBlock}
        </div>
      </div>
      ${removeBtn}
    </div>`;
}

function reRenderItems(cart) {
  const container = $('cart-items');
  const foot = $('foot');
  if (!container) return;
  const gwpVariants = getGwpVariants();

  if (cart.item_count === 0) {
    _origFetch('/cart.js').then(r => r.json()).then(fresh => {
      if (fresh.item_count > 0) return reRenderItems(fresh);
      container.innerHTML = shipBarHTML() + `
        <div class="empty" id="empty-state"><h3>Oops! Your cart is empty</h3></div>
        <div id="rec-block"></div>
        <div id="upsell-block"></div>`;
      if (foot) foot.style.display = 'none';
      updateShippingBar(0, fresh);
      renderRecs(fresh);
    }).catch(err => console.warn('[cart] verify failed:', err.message));
    return;
  }

  if (foot) foot.style.display = '';
  container.innerHTML = shipBarHTML() +
    cart.items.map(i => itemHTML(i, gwpVariants)).join('') +
    `<div id="rec-block"></div><div id="upsell-block"></div>`;

  updateShippingBar(getNonGwpTotal(cart), cart);
  renderUpsell(cart);
}

function updatePriceUI(key, newQty, prevQty) {
  const pEl = $('p-' + key);
  if (!pEl || pEl.textContent === 'Included' || pEl.textContent === '$0.00' || prevQty <= 0) return;

  const currentLine = parseFloat(pEl.textContent.replace('$', ''));
  const unit = currentLine / prevQty;
  const newLine = unit * newQty;
  const delta = newLine - currentLine;
  pEl.textContent = '$' + newLine.toFixed(2);

  const subEl = $('sub');
  if (subEl) {
    const cur = parseFloat(subEl.textContent.replace('$', ''));
    subEl.textContent = '$' + Math.max(0, cur + delta).toFixed(2);
  }

  const totalEl = $('total');
  if (totalEl) {
    const cur = parseFloat(totalEl.textContent.replace('$', ''));
    totalEl.textContent = '$' + Math.max(0, cur + delta).toFixed(2);
  }

  const qtyDiff = newQty - prevQty;
  document.querySelectorAll('.cart-badge, #hbadge, #cpill').forEach(el => {
    const cur = parseInt(el.textContent) || 0;
    el.textContent = Math.max(0, cur + qtyDiff);
  });
}

function chQty(key, delta) {
  const qEl = $('q-' + key);
  if (!qEl) return;
  const currentQty = parseInt(qEl.value) || 0;
  const newQty = Math.max(0, currentQty + delta);
  if (newQty === 0) { rmItem(key); return; }
  qEl.value = newQty;
  updatePriceUI(key, newQty, currentQty);
  debounceCartUpdate(key);
}

function setQty(key, value) {
  const newQty = parseInt(value);
  if (isNaN(newQty) || newQty < 1) return;
  const qEl = $('q-' + key);
  const prevQty = parseInt(qEl?.dataset.prev) || newQty;
  updatePriceUI(key, newQty, prevQty);
  if (qEl) qEl.dataset.prev = newQty;
  debounceCartUpdate(key);
}

function debounceCartUpdate(key) {
  clearTimeout(qtyTimers[key]);
  qtyTimers[key] = setTimeout(() => {
    const finalQty = parseInt($('q-' + key)?.value) || 0;
    if (finalQty === 0) { rmItem(key); return; }
    _origFetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: finalQty })
    }).then(r => r.json()).then(applyCart).catch(err => console.warn('[cart] qty update failed:', err.message));
  }, 400);
}

function fadeOutItem(key) {
  const el = document.querySelector(`[data-key="${key}"]`);
  if (el) { el.classList.add('removing'); setTimeout(() => el.remove(), 160); }
}

function rmItem(key) {
  fadeOutItem(key);
  _origFetch('/cart/change.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(r => r.json()).then(applyCart).catch(err => console.warn('[cart] remove failed:', err.message));
  hcToast('Removed');
}

function getSlots(prefix, count) {
  const el = getCartEl();
  if (!el) return [];
  const slots = [];
  for (let i = 1; i <= count; i++) {
    const variantId = el.dataset[`${prefix}${i}Variant`];
    if (variantId) slots.push({
      variantId, index: i,
      discountCode: el.dataset[`${prefix}${i}Discount`] || '',
      discountPct: parseFloat(el.dataset[`${prefix}${i}DiscountPct`]) || 0
    });
  }
  return slots;
}

function fetchVariant(variantId) {
  if (variantCache[variantId]) return Promise.resolve(variantCache[variantId]);
  try {
    const cached = sessionStorage.getItem(`hc_variant_${variantId}`);
    if (cached) {
      const v = JSON.parse(cached);
      variantCache[variantId] = v;
      return Promise.resolve(v);
    }
  } catch(e) {}

  return _origFetch(`/variants/${variantId}.js`).then(r => r.json()).then(v => {
    const needsProductFallback = !v.featured_image && (v.product_id || v.featured_image?.product_id);
    if (needsProductFallback) {
      const pid = v.product_id || v.featured_image.product_id;
      return _origFetch(`/products/${pid}.js`).then(r => r.json()).then(p => {
        if (!v.featured_image && p.images?.[0]) v.featured_image = { src: p.images[0].src || p.images[0] };
        if (!v.product_title) v.product_title = p.title;
        return cacheVariant(variantId, v);
      });
    }
    return cacheVariant(variantId, v);
  });
}

function cacheVariant(variantId, v) {
  variantCache[variantId] = v;
  try { sessionStorage.setItem(`hc_variant_${variantId}`, JSON.stringify(v)); } catch(e) {}
  return v;
}

function renderProductCard(v, onclick, discountPct = 0) {
  const pct = parseFloat(discountPct) || 0;
  const discounted = pct > 0 ? Math.round(v.price * (1 - pct / 100)) : null;
  const imgUrl = v.featured_image?.src || v.featured_image?.url || null;
  const imgInner = imgUrl
    ? `<img src="${imgUrl}" alt="${v.product_title || v.name}" loading="lazy" decoding="async">`
    : `<div class="pc-img-fallback">${(v.product_title || v.name).slice(0,4).toUpperCase()}</div>`;
  const priceHTML = discounted
    ? `<div class="pc-save">${pct}% off</div><div class="pc-pricing"><span class="pc-was">${formatMoney(v.price)}</span><span class="pc-price">${formatMoney(discounted)}</span></div>`
    : `<div class="pc-price">${formatMoney(v.price)}</div>`;
  return `
    <div class="pc">
      <div class="pc-img">${imgInner}</div>
      <div class="pc-name">${v.product_title || v.name}</div>
      ${priceHTML}
      <button class="pc-btn" type="button" onclick="${onclick}">Add to Cart</button>
    </div>`;
}

function renderRecs(cart) {
  const block = $('rec-block');
  if (!block || cart.item_count > 0) { if (block) block.innerHTML = ''; return; }
  const el = getCartEl();
  if (!el) { block.innerHTML = ''; return; }
  const cols = [1, 2, 3, 4].map(i => ({
    label: el.dataset[`col${i}Label`],
    url: el.dataset[`col${i}Url`],
    img: el.dataset[`col${i}Img`]
  })).filter(c => c.label && c.url);
  if (!cols.length) { block.innerHTML = ''; return; }
  block.innerHTML = `
    <div class="col-grid">
      ${cols.map(c => `
        <a class="col-card" href="${c.url}" onclick="closeCart()">
          <div class="col-tile-wrap">${c.img ? `<img class="col-img" src="${c.img}" alt="${c.label}" loading="lazy">` : ''}</div>
          <div class="col-label">${c.label}</div>
        </a>`).join('')}
    </div>`;
}

function renderUpsell(cart) {
  const block = $('upsell-block');
  if (!block || cart.item_count === 0) { if (block) block.innerHTML = ''; return; }
  const el = getCartEl();
  const heading = el?.dataset.upsellHeading || 'Add To Your Order';
  const cartVariantIds = cart.items.map(i => String(i.variant_id));
  const slots = getSlots('upsell', 4).filter(s => !cartVariantIds.includes(String(s.variantId)));
  if (!slots.length) { block.innerHTML = ''; return; }
  const skeletons = slots.map(() =>
    `<div class="pc-skeleton"><div class="sk-img"></div><div class="sk-line"></div><div class="sk-line short"></div><div class="sk-line sk-btn"></div></div>`
  ).join('');
  block.innerHTML = `<div class="pc-section"><div class="pc-heading">${heading}</div><div class="pc-row" id="upsell-row">${skeletons}</div></div>`;
  Promise.all(slots.map(s => fetchVariant(s.variantId))).then(results => {
    const row = $('upsell-row');
    if (!row) return;
    row.innerHTML = results.map((v, i) => {
      const slot = slots[i];
      return renderProductCard(v, `addProduct('${v.id}','upsell',${slot.index})`, slot.discountPct);
    }).join('');
  }).catch(err => console.warn('[cart] upsell fetch failed:', err.message));
}

function addProduct(variantId, source, slotIndex) {
  const btn = event.target;
  const card = btn.closest('.pc');
  if (card) {
    card.style.opacity = '0.4';
    card.style.pointerEvents = 'none';
    btn.textContent = '✓ Added';
  }
  const el = getCartEl();
  const discountCode = (source === 'upsell' && el && slotIndex)
    ? el.dataset[`upsell${slotIndex}Discount`] || null : null;

  _origFetch('/cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(addedItem => {
    const pct = el && slotIndex ? parseFloat(el.dataset[`upsell${slotIndex}DiscountPct`]) || 0 : 0;
    const effectivePrice = pct > 0 ? Math.round(addedItem.price * (1 - pct / 100)) : addedItem.price;
    const sub = $('sub'), total = $('total');
    if (sub) sub.textContent = formatMoney(parseFloat(sub.textContent.replace('$','')) * 100 + effectivePrice);
    if (total) total.textContent = formatMoney(parseFloat(total.textContent.replace('$','')) * 100 + effectivePrice);

    if (discountCode) {
      return _origFetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: discountCode })
      }).then(r => r.json());
    }
    return _origFetch('/cart.js').then(r => r.json());
  })
  .then(applyCart)
  .then(() => hcToast('Added to cart'))
  .catch(err => {
    console.error('[cart] add failed:', err);
    if (card) { card.style.opacity = ''; card.style.pointerEvents = ''; btn.textContent = 'Add to Cart'; }
  });
}

function hcToast(msg) {
  let el = document.querySelector('.hc-toast');
  if (!el) { el = document.createElement('div'); el.className = 'hc-toast'; document.body.appendChild(el); }
  el.textContent = msg;
  el.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el.classList.remove('show'), 2200);
}

window.fetch = function(...args) {
  const url = args[0];
  const isAdd = typeof url === 'string' && url.includes('/cart/add');
  return _origFetch.apply(this, args).then(response => {
    if (isAdd && response.ok) setTimeout(() => { openCart(); refreshCart(); }, 100);
    return response;
  });
};

const _origXhrOpen = XMLHttpRequest.prototype.open;
const _origXhrSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.open = function(method, url, ...rest) {
  this._isCartAdd = typeof url === 'string' && url.includes('/cart/add');
  return _origXhrOpen.call(this, method, url, ...rest);
};
XMLHttpRequest.prototype.send = function(...args) {
  if (this._isCartAdd) {
    this.addEventListener('load', () => {
      if (this.status >= 200 && this.status < 300) {
        setTimeout(() => { openCart(); refreshCart(); }, 100);
      }
    });
  }
  return _origXhrSend.apply(this, args);
};

document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('overlay');
  if (overlay && overlay.parentElement !== document.body) document.body.appendChild(overlay);

  // Hijack cart icon clicks
  document.addEventListener('click', e => {
    const cartBtn = e.target.closest('.cart-drawer-button');
    if (!cartBtn) return;
    e.preventDefault();
    e.stopPropagation();
    openCart();
  });

  _origFetch('/cart.js').then(r => r.json()).then(applyCart).catch(err => console.warn('[cart] init failed:', err.message));

  // Outside-click closes drawer
  document.addEventListener('click', e => {
    const cart = document.getElementById('cart');
    if (!cart?.classList.contains('open')) return;
    if (cart.contains(e.target)) return;
    if (e.target.closest('.cart-drawer-button')) return;
    closeCart();
  });

  document.addEventListener('cart:updated', refreshCart);
  document.addEventListener('theme:cart:change', refreshCart);

  const cartCountEl = document.querySelector('cart-count');
  if (cartCountEl) {
    new MutationObserver(() => {
      const count = parseInt(cartCountEl.textContent);
      if (!isNaN(count)) document.querySelectorAll('#cpill').forEach(el => el.textContent = count);
    }).observe(cartCountEl, { childList: true, characterData: true, subtree: true });
  }
});